import ProfileScreen from "@/src/screens/profile/profile";

export default function Profile() {
  return <ProfileScreen />;
}
